module.exports = __webpack_public_path__ + "static/media/banner-768.3e05f708.jpg";